import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import CardHeader from '@mui/material/CardHeader';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

function SubscriptionCard(props) {
    const { title, price, table } = props;

    return (
        <Card sx={{ minWidth: 300, maxWidth: 400 }}>
            <CardHeader
                title={title}
                sx={(theme) => ({
                    background: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText
                })}
            />
            <Box py={2}>
                <Grid container alignItems='center' justifyContent='center'>
                    <Typography variant='h3'>{price.amount}</Typography>
                    <Typography variant='body1'>{price.frequency}</Typography>
                </Grid>
            </Box>
            <CardContent>
                <Table size='small' aria-label='a dense table'>
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell align='right'></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {table.map((t) => (
                            <TableRow key={t.key}>
                                <TableCell component='th' scope='row'>
                                    {t.key}
                                </TableCell>
                                <TableCell align='right'>{t.value}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
}

export default SubscriptionCard;
